import { BasePage } from '@/components/ui/base-page'

export function APIPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add APIPage specific content here */}
    </BasePage>
  )
}